import { Mail, MessageCircle, FileText } from 'lucide-react';

export default function Support() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="/logo.png"
            alt="Hubtractor" 
            className="h-16 mx-auto mb-4"
          />
          <h1 className="text-3xl font-bold text-gray-900">Support</h1>
          <p className="text-gray-600 mt-2">We're here to help</p>
        </div>

        {/* Contact Card */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h2>
          <div className="space-y-4">
            <a 
              href="mailto:info@frequencyentertainment.net"
              className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Mail className="w-6 h-6 text-hub-600" />
              <div>
                <p className="font-medium text-gray-900">Email Support</p>
                <p className="text-sm text-gray-600">info@frequencyentertainment.net</p>
              </div>
            </a>
          </div>
        </div>

        {/* FAQ */}
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Frequently Asked Questions</h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium text-gray-900">How do I accept a gig?</h3>
              <p className="text-sm text-gray-600 mt-1">
                When you're assigned a gig, you'll receive a push notification. Open the app, go to your Dashboard or Schedule, and tap the gig to accept or decline.
              </p>
            </div>
            <div>
              <h3 className="font-medium text-gray-900">How do I see my earnings?</h3>
              <p className="text-sm text-gray-600 mt-1">
                Go to the Earnings tab to see your pay by period. Earnings are calculated after each gig date passes.
              </p>
            </div>
            <div>
              <h3 className="font-medium text-gray-900">How do I update my profile?</h3>
              <p className="text-sm text-gray-600 mt-1">
                Tap Profile in the menu to update your name, phone, photo, and notification preferences.
              </p>
            </div>
            <div>
              <h3 className="font-medium text-gray-900">I'm not receiving notifications</h3>
              <p className="text-sm text-gray-600 mt-1">
                Make sure notifications are enabled in your device settings for Hubtractor. Also check that SMS Opt-In is enabled in your Profile if you want text messages.
              </p>
            </div>
            <div>
              <h3 className="font-medium text-gray-900">I accidentally declined a gig</h3>
              <p className="text-sm text-gray-600 mt-1">
                Open the gig details and tap "Request Gig Back" to notify your manager that you'd like to be reassigned.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500 mt-8">
          © {new Date().getFullYear()} Hubtractor. All rights reserved.
        </p>
      </div>
    </div>
  );
}
